import { useStaticQuery, graphql } from "gatsby";

const GiftingProductsQuery = () => {
  const giftingProductsData = useStaticQuery<Queries.Query>(graphql`
    query GiftingProductsDataQuery {
      allSanityGiftingLandingPage {
        nodes {
          products {
            ...sanityGiftingProductPreview
          }
          productsAu {
            ...sanityGiftingProductPreviewAu
          }
        }
      }
    }
  `);

  return giftingProductsData;
};

export default GiftingProductsQuery;
